/**
 * Hide prices for products with "Comingsoon" tag
 * Apply to: Homepage, Collection Pages, Product Page
 * OPTIMIZED: Clean, efficient, no race conditions
 */
(function() {
  'use strict';
  
  const COMINGSOON_TAG = 'Comingsoon';
  const PROCESSING_ATTR = 'data-price-check-done';
  
  // Cấu hình selectors theo theme
  const CONFIG = {
    productCardSelectors: [
      '.grid-product',
      '.product-card',
      '.product-item',
      '[class*="product-grid"]',
      '[class*="product__card"]'
    ],
    priceSelectors: [
      '.grid-product__price',
      '.product__price',
      '.product-card__price',
      '.price',
      '.price-item',
      '.cx-productcard-promo-with-tooltip'
    ],
    productPagePriceSelectors: [
      '.product-block.product-block--price',
      '.product__price',
      '.product-single__price',
      '.product-block--price',
      '.price-container',
      '.price__regular',
      '.price__sale',
      '.cx-productcard-promo-with-tooltip'
    ],
    metaSelectors: [
      '.grid-product__meta',
      '.product__meta',
      '.product-card__info',
      '.product-info'
    ]
  };
  
  // ✅ Global CSS injection (chỉ chạy 1 lần)
  function injectGlobalStyles() {
    if (document.getElementById('comingsoon-dynamic-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'comingsoon-dynamic-styles';
    style.textContent = `
      /* Dynamic styles for Coming Soon products */
      .price-hidden-comingsoon {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        height: 0 !important;
        overflow: hidden !important;
        margin: 0 !important;
        padding: 0 !important;
      }
      
      /* Additional safety net for product cards */
      .product-comingsoon .cx-productcard-promo-with-tooltip {
        display: none !important;
      }
      
      /* Ensure badge visibility */
      .badge-comingsoon,
      .badge-comingsoon-large {
        display: inline-block !important;
        visibility: visible !important;
        opacity: 1 !important;
      }
    `;
    document.head.appendChild(style);
    console.log('✅ Dynamic styles injected');
  }
  
  // Main function: Ẩn giá cho sản phẩm Coming Soon (Collection/Home pages)
  function hideComingSoonPrices() {
    console.log('🔍 [Collection] Scanning for Coming Soon products...');
    
    let productCards = [];
    CONFIG.productCardSelectors.forEach(function(selector) {
      const cards = document.querySelectorAll(selector);
      cards.forEach(function(card) {
        // Skip nếu đã xử lý hoặc đang xử lý
        const processStatus = card.getAttribute(PROCESSING_ATTR);
        if (processStatus === 'true' || processStatus === 'processing') return;
        if (!productCards.includes(card)) {
          productCards.push(card);
        }
      });
    });
    
    console.log('📦 [Collection] Found ' + productCards.length + ' unprocessed product cards');
    
    productCards.forEach(function(card) {
      const productLink = card.querySelector('a[href*="/products/"]');
      
      if (!productLink) {
        card.setAttribute(PROCESSING_ATTR, 'no-link');
        return;
      }
      
      // Đánh dấu đang xử lý
      card.setAttribute(PROCESSING_ATTR, 'processing');
      
      const productUrl = productLink.getAttribute('href').split('?')[0];
      
      fetch(productUrl + '.js')
        .then(function(response) {
          if (!response.ok) throw new Error('Failed to fetch product');
          return response.json();
        })
        .then(function(product) {
          // Đánh dấu đã xong
          card.setAttribute(PROCESSING_ATTR, 'true');
          
          const hasComingSoonTag = product.tags && product.tags.some(function(tag) {
            return tag.toLowerCase() === COMINGSOON_TAG.toLowerCase();
          });
          
          if (hasComingSoonTag) {
            console.log('✅ [Collection] Coming Soon product found: "' + product.title + '"');
            hideProductPrice(card, product.title);
          } else {
            console.log('ℹ️ [Collection] Regular product: "' + product.title + '"');
          }
        })
        .catch(function(error) {
          card.setAttribute(PROCESSING_ATTR, 'error');
          console.error('❌ [Collection] Error fetching product:', error);
        });
    });
  }
  
  // Function: Ẩn giá và thêm badge (Collection pages)
  function hideProductPrice(productCard, productTitle) {
    // Dùng class CSS để ẩn
    CONFIG.priceSelectors.forEach(function(selector) {
      const priceElements = productCard.querySelectorAll(selector);
      priceElements.forEach(function(el) {
        el.classList.add('price-hidden-comingsoon');
      });
    });
    
    productCard.classList.add('product-comingsoon');
    addComingSoonBadge(productCard);
  }
  
  // Function: Thêm badge Coming Soon
  function addComingSoonBadge(productCard) {
    // Check đã có badge chưa
    if (productCard.querySelector('.badge-comingsoon')) return;
    
    let targetElement = null;
    
    // Tìm vị trí tốt nhất để đặt badge
    for (let i = 0; i < CONFIG.metaSelectors.length; i++) {
      targetElement = productCard.querySelector(CONFIG.metaSelectors[i]);
      if (targetElement) break;
    }
    
    // Fallback: tìm bất kỳ element nào có class chứa "product"
    if (!targetElement) {
      targetElement = productCard.querySelector('[class*="product"]');
    }
    
    if (!targetElement) {
      console.warn('⚠️ Cannot find target element for badge in:', productCard);
      return;
    }
    
    const badge = document.createElement('div');
    badge.className = 'badge-comingsoon';
    badge.innerHTML = '<span>Sắp Ra Mắt</span>';
    
    targetElement.appendChild(badge);
    console.log('✅ Badge added to product card');
  }
  
  // Function: Xử lý riêng cho Product Page
  function handleProductPage() {
    console.log('🔍 [Product Page] Checking if this is Product Page...');
    
    // Check đã xử lý chưa
    const processStatus = document.body.getAttribute(PROCESSING_ATTR);
    if (processStatus === 'true' || processStatus === 'processing') {
      console.log('⏭️ [Product Page] Already processed (status: ' + processStatus + '), skipping...');
      return;
    }
    
    // Detect Product Page
    const isProductPage = document.body.classList.contains('template-product') ||
                          document.body.classList.contains('product-template') ||
                          document.querySelector('.product-single') ||
                          document.querySelector('[data-section-type="product"]') ||
                          window.location.pathname.includes('/products/');
    
    if (!isProductPage) {
      console.log('❌ [Product Page] Not a Product Page');
      document.body.setAttribute(PROCESSING_ATTR, 'not-product-page');
      return;
    }
    
    console.log('✅ [Product Page] Product Page detected');
    
    // Đánh dấu đang xử lý
    document.body.setAttribute(PROCESSING_ATTR, 'processing');
    
    let productData = null;
    
    // Try 1: data-product-json attribute
    const productJSONEl = document.querySelector('[data-product-json]');
    if (productJSONEl && productJSONEl.textContent.trim()) {
      try {
        productData = JSON.parse(productJSONEl.textContent);
        console.log('📦 [Product Page] Data found from [data-product-json]');
      } catch(e) {
        console.error('❌ [Product Page] Error parsing JSON from [data-product-json]:', e);
      }
    }
    
    // Try 2: script tag với type="application/json"
    if (!productData) {
      const scriptTags = document.querySelectorAll('script[type="application/json"]');
      scriptTags.forEach(function(script) {
        if (productData) return; // Đã tìm thấy rồi
        
        const content = script.textContent.trim();
        if (!content) return;
        
        try {
          const parsed = JSON.parse(content);
          // Check xem có phải product data không
          if (parsed && (parsed.id || parsed.product_id || parsed.title || parsed.tags)) {
            productData = parsed;
            console.log('📦 [Product Page] Data found from <script type="application/json">');
          }
        } catch(e) {
          // Không phải JSON hợp lệ, skip
        }
      });
    }
    
    // Try 3: Từ window object
    if (!productData && typeof window.ShopifyProduct !== 'undefined') {
      productData = window.ShopifyProduct;
      console.log('📦 [Product Page] Data found from window.ShopifyProduct');
    }
    
    // Try 4: Fetch từ URL
    if (!productData) {
      console.log('🔄 [Product Page] Fetching product data from current URL...');
      const currentUrl = window.location.pathname;
      
      fetch(currentUrl + '.js')
        .then(function(response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.json();
        })
        .then(function(product) {
          console.log('📦 [Product Page] Data fetched successfully');
          processProductPageData(product);
        })
        .catch(function(error) {
          console.error('❌ [Product Page] Error fetching product data:', error);
          // Đánh dấu lỗi - KHÔNG ẩn giá
          document.body.setAttribute(PROCESSING_ATTR, 'fetch-error');
        });
      
      return; // Exit để đợi fetch async
    }
    
    // Nếu đã có data, process ngay
    if (productData) {
      processProductPageData(productData);
    } else {
      console.warn('⚠️ [Product Page] No product data found, prices will remain visible');
      document.body.setAttribute(PROCESSING_ATTR, 'no-data');
    }
  }
  
  // Function: Process product data
  function processProductPageData(product) {
    console.log('📊 [Product Page] Processing product: "' + product.title + '"');
    console.log('🏷️ [Product Page] Product tags:', product.tags);
    
    const hasComingSoonTag = product.tags && product.tags.some(function(tag) {
      return tag.toLowerCase() === COMINGSOON_TAG.toLowerCase();
    });
    
    // Đánh dấu đã xong
    document.body.setAttribute(PROCESSING_ATTR, 'true');
    
    if (hasComingSoonTag) {
      console.log('✅ [Product Page] Coming Soon product detected! Hiding prices...');
      hideProductPagePrice();
    } else {
      console.log('ℹ️ [Product Page] Product does NOT have "' + COMINGSOON_TAG + '" tag - prices will remain VISIBLE');
    }
  }
  
  // Function: Ẩn giá trên Product Page
  function hideProductPagePrice() {
    console.log('🚫 [Product Page] Hiding prices...');
    
    let hiddenCount = 0;
    
    // Ẩn tất cả price elements
    CONFIG.productPagePriceSelectors.forEach(function(selector) {
      const elements = document.querySelectorAll(selector);
      
      if (elements.length > 0) {
        console.log('🔍 [Product Page] Found ' + elements.length + ' elements for: ' + selector);
      }
      
      elements.forEach(function(el) {
        el.classList.add('price-hidden-comingsoon');
        hiddenCount++;
      });
    });
    
    console.log('✅ [Product Page] Total price elements hidden: ' + hiddenCount);
    
    // Ẩn nút Add to Cart
    const addToCartButtons = document.querySelectorAll(
      '.product-form__cart-submit, [name="add"], .btn--add-to-cart, [type="submit"][name="add"], .product-form__submit'
    );
    
    if (addToCartButtons.length > 0) {
      console.log('🔍 [Product Page] Found ' + addToCartButtons.length + ' Add to Cart button(s)');
    }
    
    addToCartButtons.forEach(function(btn) {
      btn.classList.add('price-hidden-comingsoon');
    });
    
    // Thêm badge Coming Soon
    addProductPageBadge();
  }
  
  // Function: Thêm badge cho Product Page
  // function addProductPageBadge() {
  //   const targetContainers = [
  //     '.product-single__meta',
  //     '.product__info-wrapper',
  //     '.product-form',
  //     '.product-single',
  //     '.product__content',
  //     '[data-section-type="product"]'
  //   ];
    
  //   let badgeAdded = false;
    
  //   for (let i = 0; i < targetContainers.length; i++) {
  //     const container = document.querySelector(targetContainers[i]);
      
  //     if (container && !container.querySelector('.badge-comingsoon-large')) {
  //       const badge = document.createElement('div');
  //       badge.className = 'badge-comingsoon-large';
  //       badge.textContent = 'Sắp Ra Mắt';
        
  //       // Insert at the beginning
  //       if (container.firstChild) {
  //         container.insertBefore(badge, container.firstChild);
  //       } else {
  //         container.appendChild(badge);
  //       }
        
  //       console.log('✅ [Product Page] Badge added to: ' + targetContainers[i]);
  //       badgeAdded = true;
  //       break;
  //     }
  //   }
    
  //   if (!badgeAdded) {
  //     console.warn('⚠️ [Product Page] Could not find container to add badge');
  //   }
  // }
  
  // Initialize
  function init() {
    console.log('🚀 Hide Coming Soon Prices - Initialized (v1.1)');
    
    // Inject CSS trước
    injectGlobalStyles();
    
    // Xử lý Collection/Home pages
    hideComingSoonPrices();
    
    // Xử lý Product page
    handleProductPage();
  }
  
  // Execute when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Re-run when sections are loaded (Shopify Theme Editor)
  document.addEventListener('shopify:section:load', function() {
    console.log('🔄 Section reloaded, re-initializing...');
    
    // Reset processing flags cho product cards (không reset body)
    const cards = document.querySelectorAll('[' + PROCESSING_ATTR + ']');
    cards.forEach(function(card) {
      if (card !== document.body) {
        card.removeAttribute(PROCESSING_ATTR);
      }
    });
    
    setTimeout(function() {
      hideComingSoonPrices();
    }, 300);
  });
  
  // Re-run for AJAX content (infinite scroll, quick view, etc.)
  const observer = new MutationObserver(function(mutations) {
    let shouldRerun = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            // Check if it's a product card or contains product cards
            const isProductCard = node.classList && (
              node.classList.contains('grid-product') ||
              node.classList.contains('product-card') ||
              node.classList.contains('product-item')
            );
            
            const containsProductCard = node.querySelector && (
              node.querySelector('.grid-product') ||
              node.querySelector('.product-card') ||
              node.querySelector('.product-item')
            );
            
            if (isProductCard || containsProductCard) {
              shouldRerun = true;
            }
          }
        });
      }
    });
    
    if (shouldRerun) {
      console.log('🔄 New products detected via MutationObserver, re-scanning...');
      setTimeout(hideComingSoonPrices, 500);
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
})();
